module.exports = __webpack_public_path__ + "static/media/demo_banner_pattern.7cc200b2.png";